import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import { useEffect } from "react";
import { useHistory, useParams } from "react-router";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import mime from "mime";
import { saveAs } from "file-saver";
import DoubleScrollbar from "react-double-scrollbar";
import CostDialog from "../../Planner/containers/CostDialog";

export default function DetailWorkOrder() {
  const history = useHistory();
  const { id } = useParams();
  const [detail, setDetail] = useState(null);
  const [data, setData] = useState([]);
  const [venderData, setVenderData] = useState([]);
  const [status, setStatus] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingType, setLoadingType] = useState("");
  const [eirNo, setEirNo] = useState("");
  const [voyOut, setVoyOut] = useState([]);

  const [editTruckPlan, setEditTruckPlan] = useState(false);
  const [truckPlanDraft, setTruckPlanDraft] = useState([]);
  const [savingTruckPlan, setSavingTruckPlan] = useState(false);

  const [costOpen, setCostOpen] = useState(false);
  const [costContainer, setCostContainer] = useState(null);
  const openCost = (row) => {
    setCostContainer(row);
    setCostOpen(true);
  };
  const truckingVenders = venderData.filter(
    (v) => v?.VenderType === "Trucking Agent"
  );

  const truckPlanVenders = Array.from(
    new Set(
      (detail?.TruckPlan || [])
        .map((p) => p?.Vender)
        .filter((v) => !!v)
    )
  );

  const filteredTruckOptions = (vender) => {
    const list = detail?.TruckNoList || [];
    if (!vender) return list;
    return list.filter((t) => t?.VenderName === vender);
  };

  const startEditTruckPlan = () => {
    setTruckPlanDraft(
      (detail?.TruckPlan || []).map((x) => ({
        TruckRequest: !!x.TruckRequest,
        Vender: x.Vender || "",
        NumberOfTrucks: x.NumberOfTrucks || 0,
      }))
    );
    setEditTruckPlan(true);
  };

  const cancelEditTruckPlan = () => {
    setEditTruckPlan(false);
    setTruckPlanDraft([]);
  };

  const updateTruckPlanRow = (index, field, value) => {
    setTruckPlanDraft((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
  };

  const addTruckPlanRow = () => {
    setTruckPlanDraft((prev) => [
      ...prev,
      { TruckRequest: false, Vender: "", NumberOfTrucks: 0 },
    ]);
  };

  const removeTruckPlanRow = (index) => {
    setTruckPlanDraft((prev) => prev.filter((_, i) => i !== index));
  };

  const saveTruckPlan = async () => {
    setSavingTruckPlan(true);
    try {
      const res = await api.post(`api/workorder/truckplan/update`, {
        WorkOrderId: id,
        TruckPlan: truckPlanDraft,
      });
      if (res?.meta?.status === true) {
        Swal.fire({
          title: res.meta.message,
          icon: "success",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK",
        }).then(() => {
          setEditTruckPlan(false);
          getDetail();
        });
      } else {
        Swal.fire({
          title: res?.meta?.message || "Save failed",
          icon: "error",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "OK",
        });
      }
    } catch (e) {
      console.log(e);
      Swal.fire({
        title: "Save failed",
        icon: "error",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
      });
    } finally {
      setSavingTruckPlan(false);
    }
  };

  const getDetail = async () => {
    const res = await api.get(`api/workorder/detail/${id}`);
    const data = await res.data;
    setDetail(data);
    setStatus(data?.ContainerManagementStatus);

    if (
      data?.OutboundVoyNo &&
      voyOut?.filter((x) => x === data?.OutboundVoyNo).length === 0
    ) {
      voyOut.push(data?.OutboundVoyNo);
    }
    if (
      data?.OutboundVoyNo_2 &&
      voyOut?.filter((x) => x === data?.OutboundVoyNo_2).length === 0
    ) {
      voyOut.push(data?.OutboundVoyNo_2);
    }
    if (
      data?.OutboundVoyNo_3 &&
      voyOut?.filter((x) => x === data?.OutboundVoyNo_3).length === 0
    ) {
      voyOut.push(data?.OutboundVoyNo_3);
    }
    setData(
      data.ContainerList.map((x) => {
        return {
          ...x,
          checkedSealCarrierNo: x.SealCarrierNo === "",
          checkedSealShipperNo: x.SealShipperNo === "",
        };
      })
    );
  };
  const getVenderList = async () => {
    try {
      const res = await api.get("api/vender/list");
      const data = await res.data;
      if (res.meta.status === true) {
        setVenderData(data.filter((x) => x?.Status === true));
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getDetail();
    getVenderList();
  }, []);

  const postData = async (obj) => {
    const body = {
      WorkOrderId: id,
      Status: true,
      ContainerList: obj ? obj : [],
      ContainerManagementStatus: status,
    };
    setIsLoading(true);
    const res = await api.post(`api/workorder/update`, body);
    if (res?.meta?.status == true) {
      setIsLoading(false);
      Swal.fire({
        title: `${res.meta.message}`,
        icon: "success",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.isConfirmed) {
          getDetail();
        }
      });
    } else {
      setIsLoading(false);
    }
  };
  const getPDF = async (type, eirNo) => {
    setLoading(true);
    setEirNo(eirNo);
    setLoadingType(type);
    await api
      .get(
        `api/report/workorder/download/pdf?workorderId=${id}&type=${type}&eirNo=${
          eirNo || ""
        }`,
        {
          responseType: "blob",
          timeout: 30000,
        }
      )
      .then((blobFile) => {
        const blobFileRes = new File([blobFile?.data], "test.pdf", {
          type: mime.getType(".pdf"),
        });

        // window.open(
        //   URL.createObjectURL(blobFileRes, "test.csv"),
        //   "_blank"
        // );
        saveAs(blobFileRes, "ReportEIR.pdf");
        setLoading(false);
        setEirNo("");
        setLoadingType("");
      });
  };

  // งานครึ่งเดียว (One-Way): ซ่อนขาที่ไม่มี + ป้ายชนิดตู้ตามจริง (ไม่ hardcode empty/laden)
  const tripType = detail?.TripType || "Round Trip";
  const tripDirection = detail?.TripDirection || "";
  const isOneWayImport = tripType === "One-Way" && tripDirection === "Import";
  const isOneWayExport = tripType === "One-Way" && tripDirection === "Export";
  const inboundGenderLabel = detail?.InboundContainerGender || "Empty";
  const outboundGenderLabel = detail?.OutboundContainerGender || "Laden";

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                WorkOrder Detail
              </Typography>
              {/* <Typography className="textcolorgreen">
              #{saleOrderNo}
            </Typography> */}
            </Grid>
          </Grid>

          <Box sx={{ display: "flex", alignItems: "end" }}>
            <Typography
              className="textcolorBule"
              sx={{ letterSpacing: "unset", width: "200px", textAlign: "end" }}
            >
              WorkOrder/
            </Typography>
            <Typography>
              <span>&nbsp;</span> Detail
            </Typography>
          </Box>
        </div>

        <Box>
          <Box sx={{ display: "flex", marginTop: "50px" }}>
            <Grid
              container
              spacing={2}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <InputLabel id="select_status-label">Status</InputLabel>
                  <Select
                    name="select_status"
                    id="select_status"
                    value={status}
                    label="Status"
                    style={{
                      width: "100%",
                    }}
                    onChange={(e) => setStatus(e.target.value)}
                  >
                    <MenuItem value={"New"}>New</MenuItem>
                    <MenuItem value={"Processing"}>Processing</MenuItem>
                    <MenuItem value={"Done"}>Done</MenuItem>
                    <MenuItem value={"Declined"}>Declined</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={4}>
                <Button
                  sx={{ width: 80 }}
                  variant="contained"
                  style={{
                    background: "#80c340",
                    borderColor: "#80c340",
                    marginRight: "10px",
                  }}
                  disabled={isLoading}
                  onClick={() => postData()}
                >
                  Save
                </Button>
              </Grid>
              <Grid item xs={4}></Grid>
              <Grid item xs={4}>
                <TextField
                  label="Customer Name"
                  value={detail?.CustomerName || ""}
                  sx={{ width: "100%" }}
                />
              </Grid>

              <Grid item xs={4}>
                {/* <TextField label="Truck Company" value={detail?.TruckCompany || ""} sx={{ width: "100%" }} /> */}
              </Grid>
              <Grid item xs={4}></Grid>

              <Grid item xs={4}>
                <TextField
                  label="Shipper Ref No"
                  value={detail?.ShipperRefNo || ""}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  label="Booking No"
                  value={detail?.BookingNo || ""}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={4}></Grid>
            </Grid>
          </Box>
          <Box sx={{ display: "flex", marginTop: "45px" }}>
            {" "}
            <Typography
              sx={{ fontWeight: "700", fontSize: "20px", color: "#30318d" }}
            >
              VOLUME
            </Typography>
          </Box>
          <Box sx={{ display: "flex", marginTop: "50px" }}>
            <Grid
              container
              spacing={2}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Grid item xs={4}>
                <TextField
                  label="Size"
                  value={detail?.Size || ""}
                  sx={{ width: "100%" }}
                />
              </Grid>

              <Grid item xs={4}>
                <TextField
                  label="Quantity"
                  value={detail?.Quantity || ""}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={4}></Grid>
              {/* <Grid item xs={2}>
                                <TextField label="Container Status" value={detail?.ContainerStockType || ""} sx={{ width: "100%" }} />
                            </Grid>
                            <Grid item xs={2}>
                                <TextField label="Grade" value={detail?.ContainerGrade || ""} sx={{ width: "100%" }} />
                            </Grid>
                            <Grid item xs={2}>
                                <TextField label="Agent Line" value={detail?.AgentLine || ""} sx={{ width: "100%" }} />
                            </Grid>
                            <Grid item xs={2}>
                                <TextField label="Plastic Sheet" value={detail?.ContainerApplyPlasticSheet ? 'yes' : 'no'} sx={{ width: "100%" }} />
                            </Grid>
                            <Grid item xs={2}>
                                <TextField label="Container Gender" value={detail?.ContainerGender || ""} sx={{ width: "100%" }} />
                            </Grid> */}
            </Grid>
          </Box>
          <Box sx={{ display: "flex", marginTop: "45px" }}>
            {" "}
            <Typography
              sx={{ fontWeight: "700", fontSize: "20px", color: "#30318d" }}
            >
              Booking Information
            </Typography>
          </Box>
          <Box sx={{ display: "flex", marginTop: "50px" }}>
            <Grid
              container
              spacing={2}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Grid item xs={4}>
                <TextField
                  label="Shipping Line"
                  value={detail?.ShippingLine || ""}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={8}></Grid>
              <Grid item xs={4}>
                <TextField
                  label="Port of Loading"
                  value={detail?.POLLocationName || ""}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  label="ETD "
                  value={
                    detail?.ETDPOLDate
                      ? detail?.ETDPOLDate
                      : "" + " " + detail?.ETDPOLTime
                      ? detail?.ETDPOLTime
                      : ""
                  }
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={4}></Grid>
              <Grid item xs={4}>
                <TextField
                  label="Port of Discharge"
                  value={detail?.PODLocationName || ""}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  label="ETA "
                  value={
                    detail?.ETAPODDate
                      ? detail?.ETAPODDate
                      : "" + " " + detail?.ETAPODTime
                      ? detail?.ETAPODTime
                      : ""
                  }
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={4}></Grid>
              <Grid item xs={4}>
                <TextField
                  label="Intended Vessel "
                  value={detail?.IntendedVessel || ""}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={8}></Grid>
              <Grid item xs={2}>
                <TextField
                  label="Container Status"
                  value={detail?.ContainerStockType || ""}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  label="Grade"
                  value={detail?.ContainerGrade || ""}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  label="Agent Line"
                  value={""}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  label="Plastic Sheet"
                  value={
                    detail?.ContainerApplyPlasticSheet ? "yes" : "no" || ""
                  }
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={2}>
                <TextField
                  label="Container Gender"
                  value={detail?.ContainerGender || ""}
                  sx={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ display: "flex", marginTop: "50px" }}>
            <Grid
              container
              spacing={2}
              columns={16}
              sx={{ display: "flex", alignItems: "center" }}
            >
              {!isOneWayExport && (
                <Grid item xs={8}>
                  <Typography
                    sx={{ fontWeight: "700", fontSize: "20px", color: "#30318d" }}
                  >
                    {inboundGenderLabel} Container
                  </Typography>
                </Grid>
              )}
              {!isOneWayImport && (
                <Grid item xs={8}>
                  <Typography
                    sx={{ fontWeight: "700", fontSize: "20px", color: "#30318d" }}
                  >
                    {outboundGenderLabel} Container
                  </Typography>
                </Grid>
              )}
              {!isOneWayExport && (
                <>
                  <Grid item xs={2}>
                    <TextField
                      label="VOY IN"
                      value={detail?.InboundVoyNo || ""}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="ETD Gate Out"
                      value={
                        detail?.InboundETDGateOut
                          ? moment(detail?.InboundETDGateOut).format("DD-MM-yyyy")
                          : "" || ""
                      }
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="ETA Gate IN"
                      value={
                        detail?.InboundETAGateIn
                          ? moment(detail?.InboundETAGateIn).format("DD-MM-yyyy")
                          : "" || ""
                      }
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="Inbound Quantity"
                      value={detail?.InboundQuantity || ""}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                </>
              )}
              {!isOneWayImport && (
                <>
                  <Grid item xs={2}>
                    <TextField
                      label="VOY OUT"
                      value={detail?.OutboundVoyNo || ""}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="ETD Gate Out"
                      value={
                        detail?.OutboundETDGateOut
                          ? moment(detail?.OutboundETDGateOut).format("DD-MM-yyyy")
                          : "" || ""
                      }
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="ETA Gate IN"
                      value={
                        detail?.OutboundETAGateIn
                          ? moment(detail?.OutboundETAGateIn).format("DD-MM-yyyy")
                          : "" || ""
                      }
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="Outbound Quantity"
                      value={detail?.OutboundQuantity || ""}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                </>
              )}
              {detail?.InboundTransportGroupId === "G002" ||
              detail?.OutboundTransportGroupId === "G002" ? (
                <>
                  <Grid item xs={2}>
                    <TextField
                      label="VOY IN"
                      value={detail?.InboundVoyNo_2 || ""}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="ETD Gate Out"
                      value={
                        detail?.InboundETDGateOut_2
                          ? moment(detail?.InboundETDGateOut_2).format(
                              "DD-MM-yyyy"
                            )
                          : "" || ""
                      }
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="ETA Gate IN"
                      value={
                        detail?.InboundETAGateIn_2
                          ? moment(detail?.InboundETAGateIn_2).format(
                              "DD-MM-yyyy"
                            )
                          : "" || ""
                      }
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="Inbound Quantity"
                      value={detail?.InboundQuantity_2 || ""}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="VOY OUT"
                      value={detail?.OutboundVoyNo_2 || ""}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="ETD Gate Out"
                      value={
                        detail?.OutboundETDGateOut_2
                          ? moment(detail?.OutboundETDGateOut_2).format(
                              "DD-MM-yyyy"
                            )
                          : "" || ""
                      }
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="ETA Gate IN"
                      value={
                        detail?.OutboundETAGateIn_2
                          ? moment(detail?.OutboundETAGateIn_2).format(
                              "DD-MM-yyyy"
                            )
                          : "" || ""
                      }
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="Outbound Quantity"
                      value={detail?.OutboundQuantity_2 || ""}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="VOY IN"
                      value={detail?.InboundVoyNo_3 || ""}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="ETD Gate Out"
                      value={
                        detail?.InboundETDGateOut_3
                          ? moment(detail?.InboundETDGateOut_3).format(
                              "DD-MM-yyyy"
                            )
                          : "" || ""
                      }
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="ETA Gate IN"
                      value={
                        detail?.InboundETAGateIn_3
                          ? moment(detail?.InboundETAGateIn_3).format(
                              "DD-MM-yyyy"
                            )
                          : "" || ""
                      }
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="Inbound Quantity"
                      value={detail?.InboundQuantity_3 || ""}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="VOY OUT"
                      value={detail?.OutboundVoyNo_3 || ""}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="ETD Gate Out"
                      value={
                        detail?.OutboundETDGateOut_3
                          ? moment(detail?.OutboundETDGateOut_3).format(
                              "DD-MM-yyyy"
                            )
                          : "" || ""
                      }
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="ETA Gate IN"
                      value={
                        detail?.OutboundETAGateIn_3
                          ? moment(detail?.OutboundETAGateIn_3).format(
                              "DD-MM-yyyy"
                            )
                          : "" || ""
                      }
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid item xs={2}>
                    <TextField
                      label="Outbound Quantity"
                      value={detail?.OutboundQuantity_3 || ""}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                </>
              ) : (
                ""
              )}
            </Grid>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              marginTop: "45px",
            }}
          >
            <Typography
              sx={{ fontWeight: "700", fontSize: "20px", color: "#30318d" }}
            >
              Truck Plan
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            {!editTruckPlan ? (
              <Button
                variant="outlined"
                size="small"
                onClick={startEditTruckPlan}
                sx={{ color: "#80c340", borderColor: "#80c340" }}
              >
                Edit
              </Button>
            ) : (
              <>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={cancelEditTruckPlan}
                  disabled={savingTruckPlan}
                  sx={{ mr: "10px", color: "#80c340", borderColor: "#80c340" }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={saveTruckPlan}
                  disabled={savingTruckPlan}
                  sx={{ background: "#80c340" }}
                >
                  {savingTruckPlan ? <CircularProgress size={18} /> : "Save"}
                </Button>
              </>
            )}
          </Box>
          <Box sx={{ marginTop: "10px" }}>
            <TableContainer>
              <Table>
                <TableHead sx={{ backgroundColor: "#e7e7e7" }}>
                  <TableRow>
                    <TableCell sx={{ width: "20%" }}>Request Truck</TableCell>
                    <TableCell sx={{ width: editTruckPlan ? "50%" : "60%" }}>
                      Vender
                    </TableCell>
                    <TableCell sx={{ width: "20%" }}>
                      Number of Trucks
                    </TableCell>
                    {editTruckPlan && (
                      <TableCell sx={{ width: "10%" }}>Action</TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {(editTruckPlan ? truckPlanDraft : detail?.TruckPlan || []).map((x, i) => (
                    <TableRow key={i}>
                      <TableCell>
                        <FormControl
                          size="small"
                          sx={{ width: "100%", mr: "5px" }}
                        >
                          <InputLabel>Request</InputLabel>
                          <Select
                            disabled={!editTruckPlan}
                            name="container_gender_Inbound"
                            label="Request"
                            value={x?.TruckRequest ?? false}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) =>
                              updateTruckPlanRow(
                                i,
                                "TruckRequest",
                                e.target.value
                              )
                            }
                          >
                            <MenuItem value={true}>Yes</MenuItem>
                            <MenuItem value={false}>No</MenuItem>
                          </Select>
                        </FormControl>
                      </TableCell>
                      <TableCell>
                        {editTruckPlan ? (
                          <FormControl size="small" sx={{ width: "100%" }}>
                            <InputLabel>Vender</InputLabel>
                            <Select
                              label="Vender"
                              value={x?.Vender || ""}
                              onChange={(e) =>
                                updateTruckPlanRow(
                                  i,
                                  "Vender",
                                  e.target.value
                                )
                              }
                            >
                              <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                              {truckingVenders.map((v) => (
                                <MenuItem
                                  key={v.VenderId}
                                  value={v.VenderName}
                                >
                                  {v.VenderName}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        ) : (
                          <TextField
                            size="small"
                            disabled
                            label="Vender"
                            value={x?.Vender || ""}
                            sx={{ width: "100%", marginRight: "5px" }}
                          />
                        )}
                      </TableCell>
                      <TableCell>
                        <TextField
                          label="Trucks"
                          name="NumberOfTrucks"
                          type="number"
                          disabled={!editTruckPlan}
                          value={x?.NumberOfTrucks ?? 0}
                          onChange={(e) =>
                            updateTruckPlanRow(
                              i,
                              "NumberOfTrucks",
                              Number(e.target.value || 0)
                            )
                          }
                          size="small"
                          sx={{ width: "100%", marginRight: "5px" }}
                        />
                      </TableCell>
                      {editTruckPlan && (
                        <TableCell>
                          <Button
                            size="small"
                            variant="outlined"
                            color="error"
                            onClick={() => removeTruckPlanRow(i)}
                          >
                            Delete
                          </Button>
                        </TableCell>
                      )}
                    </TableRow>
                  ))}
                  {editTruckPlan && (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={addTruckPlanRow}
                          sx={{ color: "#0d6efd", borderColor: "#0d6efd" }}
                        >
                          + Add Row
                        </Button>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box sx={{ display: "flex", marginTop: "45px" }}>
            {" "}
            <Typography
              sx={{ fontWeight: "700", fontSize: "20px", color: "#30318d" }}
            >
              STUFFING PLAN
            </Typography>
          </Box>
          <Box sx={{ marginTop: "10px" }}>
            <TableContainer>
              <Table>
                <TableHead sx={{ backgroundColor: "#e7e7e7" }}>
                  <TableRow>
                    <TableCell sx={{ width: "15%" }}>Pick-up Date</TableCell>
                    <TableCell sx={{ width: "40%" }}>Factory</TableCell>
                    <TableCell sx={{ width: "15%" }}>Return Date</TableCell>
                    <TableCell sx={{ width: "15%" }}>Gate Out</TableCell>
                    <TableCell sx={{ width: "15%" }}>Quantity</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {detail?.StuffingPlan?.map((x, i) => (
                    <TableRow key={i}>
                      <TableCell>{x?.PickupDate}</TableCell>
                      <TableCell>{x?.FactoryName}</TableCell>
                      <TableCell>{x?.ReturnDate}</TableCell>
                      <TableCell>{x?.GateOut}</TableCell>
                      <TableCell>{x?.Quantity}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box
            sx={{
              marginTop: "10px",
            }}
          >
            <DoubleScrollbar>
              <Table sx={{ minWidth: 2600 }}>
                <TableHead sx={{ backgroundColor: "#e7e7e7" }}>
                  <TableRow>
                    <TableCell sx={{}}>
                      <Checkbox
                        size="small"
                        // sx={{
                        //     color: '#fff',

                        //     "&.Mui-checked": {
                        //         color: '#fff',
                        //     },
                        // }}

                        onChange={(e) => {
                          const io = data?.map((v) => {
                            v.isCheck =
                              e.target.checked === true && v?.Status !== 0
                                ? true
                                : false;

                            return v;
                          });

                          setData([...io]);
                        }}
                      />
                    </TableCell>
                    <TableCell sx={{ minWidth: "160px" }}>Container No.</TableCell>
                    <TableCell sx={{ minWidth: "160px" }}>Seal Shipper</TableCell>
                    <TableCell sx={{ minWidth: "160px" }}>Seal Carrier No.</TableCell>
                    <TableCell sx={{ minWidth: "260px" }}>Vender MT (Pick-up)</TableCell>
                    <TableCell sx={{ minWidth: "200px" }}>Pick-up Truck No.</TableCell>
                    <TableCell sx={{ minWidth: "180px" }}>Date</TableCell>
                    <TableCell sx={{ minWidth: "130px" }}>Time</TableCell>
                    <TableCell sx={{ minWidth: "260px" }}>Vender LD (Return)</TableCell>
                    <TableCell sx={{ minWidth: "200px" }}>Return Truck No.</TableCell>
                    <TableCell sx={{ minWidth: "180px" }}>Date</TableCell>
                    <TableCell sx={{ minWidth: "130px" }}>Time</TableCell>
                    <TableCell sx={{ minWidth: "110px" }}>Voy In</TableCell>
                    <TableCell sx={{ minWidth: "160px" }}>EIR MT No.</TableCell>
                    <TableCell sx={{ minWidth: "160px" }}>EIR LD No.</TableCell>
                    <TableCell sx={{ minWidth: "200px" }}>Voy Out</TableCell>
                    <TableCell sx={{ minWidth: "110px" }}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.map((x, i) => (
                    <TableRow key={i}>
                      <TableCell>
                        <Checkbox
                          size="small"
                          // sx={{
                          //     color: green[500],
                          //     "&.Mui-checked": {
                          //         color: green[500],
                          //     },
                          // }}
                          onChange={(e) => {
                            const io = data?.map((y) => {
                              y.isCheck =
                                y?.StockMovementID === x?.StockMovementID
                                  ? e.target.checked === true
                                    ? true
                                    : false
                                  : y?.isCheck;
                              return y;
                            });

                            setData([...io]);
                          }}
                          checked={x?.isCheck ? true : false}
                        />
                      </TableCell>
                      <TableCell>{x?.ContainerNo}</TableCell>
                      <TableCell>
                        {!x?.checkedSealShipperNo ? (
                          x?.SealShipperNo
                        ) : (
                          <TextField
                            label="SealShipperNo"
                            value={x?.SealShipperNo || ""}
                            onChange={(e) => {
                              const io = data?.map((v) => {
                                v.SealShipperNo =
                                  v?.StockMovementID === x?.StockMovementID
                                    ? e.target.value
                                    : v?.SealShipperNo;

                                return v;
                              });

                              setData([...io]);
                            }}
                          />
                        )}
                      </TableCell>
                      <TableCell>
                        {!x?.checkedSealCarrierNo ? (
                          x?.SealCarrierNo
                        ) : (
                          <TextField
                            label="SealCarrierNo"
                            value={x?.SealCarrierNo || ""}
                            onChange={(e) => {
                              const io = data?.map((v) => {
                                v.SealCarrierNo =
                                  v?.StockMovementID === x?.StockMovementID
                                    ? e.target.value
                                    : v?.SealCarrierNo;
                                return v;
                              });
                              setData([...io]);
                            }}
                          />
                        )}
                      </TableCell>
                      <TableCell>
                        <FormControl size="small" sx={{ width: "100%" }}>
                          <InputLabel>Vender</InputLabel>
                          <Select
                            label="Vender"
                            value={x?.VenderMT || ""}
                            onChange={(e) => {
                              const newVender = e.target.value;
                              const io = data?.map((v) => {
                                if (
                                  v?.StockMovementID === x?.StockMovementID
                                ) {
                                  v.VenderMT = newVender;
                                  if (
                                    v.PickupTruckNo &&
                                    !(detail?.TruckNoList || []).some(
                                      (t) =>
                                        t?.VehicleNo === v.PickupTruckNo &&
                                        t?.VenderName === newVender
                                    )
                                  ) {
                                    v.PickupTruckNo = "";
                                  }
                                }
                                return v;
                              });
                              setData([...io]);
                            }}
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            {truckPlanVenders.map((v) => (
                              <MenuItem key={`pkv-${v}`} value={v}>
                                {v}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </TableCell>
                      <TableCell>
                        <Autocomplete
                          freeSolo
                          fullWidth
                          options={filteredTruckOptions(x?.VenderMT)}
                          getOptionLabel={(option) => option?.VehicleNo || ""}
                          id="controlled-demo"
                          inputValue={x?.PickupTruckNo || ""}
                          onChange={(e, newValue) => {
                            const io = data?.map((v) => {
                              if (v?.StockMovementID === x?.StockMovementID) {
                                v.PickupTruckNo = newValue?.VehicleNo || "";
                                if (newValue?.VenderName) {
                                  v.VenderMT = newValue.VenderName;
                                }
                              }
                              return v;
                            });

                            setData([...io]);
                          }}
                          onInputChange={(e, value) => {
                            const io = data?.map((v) => {
                              v.PickupTruckNo =
                                v?.StockMovementID === x?.StockMovementID
                                  ? value
                                  : v?.PickupTruckNo;

                              return v;
                            });

                            setData([...io]);
                          }}
                          selectOnFocus
                          handleHomeEndKeys
                          renderInput={(params) => (
                            <TextField {...params} label="Pick-up Truck No." />
                          )}
                        />
                      </TableCell>
                      <TableCell>
                        {" "}
                        <DesktopDatePicker
                          label="Date"
                          inputFormat="dd/MM/yyyy"
                          // minDate={new Date(x?.PickupDate)}
                          value={x?.PickupDate || null}
                          onChange={(e) => {
                            const io = data?.map((v) => {
                              v.PickupDate =
                                v?.StockMovementID === x?.StockMovementID
                                  ? moment(e).format("yyyy-MM-DD")
                                  : v?.isCheck === true
                                  ? moment(e).format("yyyy-MM-DD")
                                  : v?.PickupDate;

                              return v;
                            });

                            setData([...io]);
                          }}
                          renderInput={(params) => (
                            <TextField sx={{ width: "100%" }} {...params} />
                          )}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          label="Time"
                          value={x?.PickupTime || ""}
                          type="time"
                          onChange={(e) => {
                            const io = data?.map((v) => {
                              v.PickupTime =
                                v?.StockMovementID === x?.StockMovementID
                                  ? e.target.value
                                  : v?.isCheck === true
                                  ? e.target.value
                                  : v?.PickupTime;

                              return v;
                            });

                            setData([...io]);
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <FormControl size="small" sx={{ width: "100%" }}>
                          <InputLabel>Vender</InputLabel>
                          <Select
                            label="Vender"
                            value={x?.Vender || ""}
                            onChange={(e) => {
                              const newVender = e.target.value;
                              const io = data?.map((v) => {
                                if (
                                  v?.StockMovementID === x?.StockMovementID
                                ) {
                                  v.Vender = newVender;
                                  if (
                                    v.ReturnTruckNo &&
                                    !(detail?.TruckNoList || []).some(
                                      (t) =>
                                        t?.VehicleNo === v.ReturnTruckNo &&
                                        t?.VenderName === newVender
                                    )
                                  ) {
                                    v.ReturnTruckNo = "";
                                  }
                                }
                                return v;
                              });
                              setData([...io]);
                            }}
                          >
                            <MenuItem value="">
                              <em>None</em>
                            </MenuItem>
                            {truckPlanVenders.map((v) => (
                              <MenuItem key={`rtv-${v}`} value={v}>
                                {v}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </TableCell>
                      <TableCell>
                        <Autocomplete
                          freeSolo
                          fullWidth
                          options={filteredTruckOptions(x?.Vender)}
                          getOptionLabel={(option) => option?.VehicleNo || ""}
                          id="controlled-demo"
                          inputValue={x?.ReturnTruckNo || ""}
                          onChange={(e, newValue) => {
                            const io = data?.map((v) => {
                              if (v?.StockMovementID === x?.StockMovementID) {
                                v.ReturnTruckNo = newValue?.VehicleNo || "";
                                if (newValue?.VenderName) {
                                  v.Vender = newValue.VenderName;
                                }
                              }
                              return v;
                            });

                            setData([...io]);
                          }}
                          onInputChange={(e, value) => {
                            const io = data?.map((v) => {
                              v.ReturnTruckNo =
                                v?.StockMovementID === x?.StockMovementID
                                  ? value
                                  : v?.ReturnTruckNo;

                              return v;
                            });

                            setData([...io]);
                          }}
                          selectOnFocus
                          handleHomeEndKeys
                          renderInput={(params) => (
                            <TextField {...params} label="Return Truck No." />
                          )}
                        />
                      </TableCell>
                      <TableCell>
                        <DesktopDatePicker
                          label="Date"
                          inputFormat="dd/MM/yyyy"
                          minDate={new Date(x?.PickupDate)}
                          value={x?.ReturnDate || null}
                          onChange={(e) => {
                            const io = data?.map((v) => {
                              v.ReturnDate =
                                v?.StockMovementID === x?.StockMovementID
                                  ? moment(e).format("yyyy-MM-DD")
                                  : v.isCheck === true
                                  ? moment(e).format("yyyy-MM-DD")
                                  : v?.ReturnDate;

                              return v;
                            });

                            setData([...io]);
                          }}
                          renderInput={(params) => (
                            <TextField sx={{ width: "100%" }} {...params} />
                          )}
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          label="Time"
                          value={x?.ReturnTime || ""}
                          type="time"
                          onChange={(e) => {
                            const io = data?.map((v) => {
                              v.ReturnTime =
                                v?.StockMovementID === x?.StockMovementID
                                  ? e.target.value
                                  : v?.isCheck === true
                                  ? e.target.value
                                  : v?.ReturnTime;

                              return v;
                            });

                            setData([...io]);
                          }}
                        />
                      </TableCell>
                      <TableCell>{x?.VoyIn}</TableCell>
                      <TableCell>
                        {x?.EIRNo ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <span>{x?.EIRNo}</span>
                            <Button
                              variant="outlined"
                              onClick={() => getPDF("MT", x?.EIRNo)}
                              fullWidth
                            >
                              {loading && x?.EIRNo === eirNo ? (
                                <CircularProgress size={22} />
                              ) : (
                                <Typography sx={{ fontSize: "14px" }}>
                                  Print EIR MT
                                </Typography>
                              )}
                            </Button>{" "}
                          </div>
                        ) : (
                          ""
                        )}
                      </TableCell>
                      <TableCell>
                        {x?.EIRNoLaden ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <span>{x?.EIRNoLaden}</span>
                            <Button
                              variant="outlined"
                              onClick={() => getPDF("LD", x?.EIRNoLaden)}
                              fullWidth
                            >
                              {loading && x?.EIRNoLaden === eirNo ? (
                                <CircularProgress size={22} />
                              ) : (
                                <Typography sx={{ fontSize: "14px" }}>
                                  Print EIR LD
                                </Typography>
                              )}
                            </Button>{" "}
                          </div>
                        ) : (
                          ""
                        )}
                      </TableCell>
                      {/* <TableCell><FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Vender</InputLabel>

                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={x?.Vender || ''}
                                                    label="Vender"
                                                    onChange={(e) => {
                                                        const io = data?.map((v) => {
                                                            v.Vender =
                                                                v?.StockMovementID === x?.StockMovementID ? e.target.value : v?.isCheck === true ? e.target.value : v?.Vender;

                                                            return v;
                                                        });

                                                        setData([...io]);
                                                    }}
                                                >
                                                    {venderData?.map((x, i) => (
                                                        <MenuItem key={i} value={x?.VenderName}>{x?.VenderName}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl></TableCell> */}
                      {/* <TableCell>{x?.VoyIn}</TableCell> */}
                      <TableCell>
                        <Autocomplete
                          name="voyOut"
                          options={voyOut}
                          getOptionLabel={(option) => option}
                          // classes={{
                          //   root:
                          //     !formik.values.serviceRoute.locationTo
                          //       ? classes.customOutline
                          //       : null,
                          // }}

                          onChange={(m, y) => {
                            const io = data?.map((v) => {
                              v.VoyOut =
                                v?.StockMovementID === x?.StockMovementID
                                  ? y
                                  : v?.isCheck === true
                                  ? y
                                  : v?.VoyOut;

                              return v;
                            });

                            setData([...io]);
                          }}
                          id="flat-demo"
                          value={x?.VoyOut || null}
                          sx={{ width: "100%" }}
                          renderInput={(params) => (
                            <TextField {...params} label="Voy Out" />
                          )}
                        />
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                          }}
                        >
                          <Button
                            sx={{ width: 80 }}
                            variant="contained"
                            style={{
                              background: "#80c340",
                              borderColor: "#80c340",
                            }}
                            disabled={isLoading}
                            onClick={() => postData([x])}
                          >
                            Save
                          </Button>
                          <Button
                            sx={{ width: 80 }}
                            variant="outlined"
                            style={{
                              color: "#30318d",
                              borderColor: "#30318d",
                            }}
                            onClick={() => openCost(x)}
                          >
                            Cost
                          </Button>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </DoubleScrollbar>
          </Box>

          <Box sx={{ display: "flex", marginTop: "25px" }}>
            <Button
              sx={{ width: 80 }}
              type="button"
              variant="outlined"
              style={{
                color: "#80c340",
                borderColor: "#80c340",
                marginRight: "10px",
              }}
              onClick={history.goBack}
            >
              close
            </Button>

            <Button
              variant="outlined"
              style={{
                background: "#fff",
                borderColor: "#C8C8C8",
                width: "150px",
              }}
              onClick={() => getPDF("MT")}
            >
              {loading && loadingType === "MT" ? (
                <CircularProgress size={22} />
              ) : (
                <Typography sx={{ color: "#8E8C8C" }}>Print EIR MT</Typography>
              )}
            </Button>
            <Button
              variant="outlined"
              style={{
                background: "#fff",
                borderColor: "#C8C8C8",
                marginLeft: "10px",
                width: "150px",
              }}
              onClick={() => getPDF("LD")}
            >
              {loading && loadingType === "LD" ? (
                <CircularProgress size={22} />
              ) : (
                <Typography sx={{ color: "#8E8C8C" }}>Print EIR LD</Typography>
              )}
            </Button>
          </Box>
        </Box>
      </Card>

      <CostDialog
        open={costOpen}
        onClose={() => setCostOpen(false)}
        saleOrderId={detail?.SaleOrderId}
        container={costContainer}
      />
    </LocalizationProvider>
  );
}
